import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { BaseRestfulService, HttpVerb } from "../base-restful.service";
import { PhoneVerificationRequest, PhoneInfo } from "../account/model";
import { AuthService } from '../auth/AuthService';

@Injectable()
export class PhoneVerificationService extends BaseRestfulService<
  PhoneVerificationRequest
> {
  private phoneVerificationUrl: string =
    "/mobileproxy/messaging/verifyphonenumber";

  constructor(protected _http: Http, private authService: AuthService) {
    super(_http);
  }

  public verifyPhone(
    info: PhoneVerificationRequest
  ): Observable<PhoneVerificationRequest> {
    return this.callApiEndPoint(info, this.phoneVerificationUrl, HttpVerb.Post, this.authService.getAuthorizationHeaderValue());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/account/phone-verify.service.ts